export default "__VITE_ASSET__CcO2UaEi__"